import { surveyFormsService } from "../../../../../Api/Services/SurveyFormsService";
import { ACTION_NAMES, SLICE_NAMES } from "../../../../../constants/action";
import { ERROR_MESSAGES } from "../../../../../constants/error";
import { ISectionListResponse } from "../../../../../Types/SurveyFormsTypes";
import createGenericSlice from "../../../../../utils/reduxUtils/createEntitySlice";
import createServiceAsyncThunk from "../../../../../utils/reduxUtils/createServiceAsyncThunk";

export const fetchSections = createServiceAsyncThunk<
  ISectionListResponse,
  void
>(
  ACTION_NAMES.LIST_SECTION,
  () => surveyFormsService.getSections(),
  ERROR_MESSAGES.LIST_SECTION_FAILURE
);

export const sectionListSlice = createGenericSlice<ISectionListResponse, void>(
  SLICE_NAMES.SECTION_LIST_SLICE,
  fetchSections
);

export const {
  clearError: clearSectionListError,
  clearSuccessMessage: clearSectionListSuccessMessage,
} = sectionListSlice.actions;

export default sectionListSlice.reducer;
